import './app.scss'
import './style.scss'

import type { SetNonNullable } from 'type-fest'
import { keys } from './injection-keys'
import Viewer from './Viewer.vue'

// The initialization function of the plugin, receiving a target element
// and the options defined in the config file as <App> root props.
export default async function (
  element: Element | string,
  options: SetNonNullable<OwnbitConfigurator.PluginOptions, 'savedState'>,
) {
  const app = createApp(Viewer)
  app.use(createPinia())
  app.provide(keys.options, options)

  const { defineStores } = await import('@/steps-meta/register-stores')
  app.runWithContext(() => {
    defineStores()
  })

  // Load saved state
  useSavedStateStore().load(options.savedState)

  // Mount application
  app.mount(element)
}
